import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  Label,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  FormGroup,
  Input,
  CustomInput,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
// import TableScrollbar from "react-table-scrollbar";
import moment from "moment";
import Swal from "sweetalert2";

import "../../Material/MaterialRequest.scss";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import ChangeItem from "../ChangeItem";
import CustomProductRightbar from "./CustomProductRightbar";
import ProductHistory from "../ProductHistory";
import ItemDetails from "../../ItemDetails";
import ProductItemHistoryLog from "../../Material/ProductItemHistoryLog";

import {
  getUserDepartment,
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  getReqestRowDetails,
  SRitemHodApproval,
  SRHodApprovedRequest,
  AllMrHodItemsChecked,
  MrHODItemsChecked,
  ChangeItemModelOpen,
  getAllProducts,
  CPRightSidebar,
  GetProductHistory,
  productItemHistoryModelOpen,
} from "../../../store/ServiceRequest/actions";
import { MRCustomProduct } from "../../../store/Masters/Products/actions";
import LoadingModel from "../../LoadingModel";

function PdfViewer({ url }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        let finalUrl = url;

        if (
          window.location.hostname === "localhost" &&
          url.startsWith("http://vendpin.dev.absol.in")
        ) {
          finalUrl = url.replace("http://vendpin.dev.absol.in", "");
        }

        const response = await fetch(finalUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (err) {
        console.error("Failed to load PDF", err);
      }
    };
    fetchPdf();
  }, [url]);

  if (!pdfBlobUrl)
    return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

  return (
    <iframe
      src={pdfBlobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}

class MaterialRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      reqStateRowData: {},
      request_items: [],
      item_details: {},
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      selectedOrderLocation: null,
      showImageModal: false,
      requestId: null,
    };

    this.itemApprovedRequest.bind(this);
    this.tog_static = this.tog_static.bind(this);
    this.updateRequest = this.updateRequest.bind(this);
    this.CPRightbar = this.CPRightbar.bind(this);
  }
  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));

    this.removeBodyCss();
  }
  reject_Item_Model(item) {
    this.setState((prevState) => ({
      rejectItemModel: !prevState.rejectItemModel,
      rejectItem: item,
      rejectItemText: "",
      rejectErrorMsg: "",
    }));
    this.removeBodyCss();
  }
  reject_Model() {
    this.setState((prevState) => ({
      rejectModel: !prevState.rejectModel,
      rejectItemText: "",
      rejectErrorMsg: "",
    }));
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidMount() {
    const requestId = this.props.match.params.id;
    this.setState({ requestId });
    this.props.getUserDepartment(requestId);
    // this.props.getReqestRowDetails(
    //   requestId,
    //   this.props.userDeparment
    // );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id && this.props.match.params.id) {
      const requestId = this.props.match.params.id;
      this.setState({ requestId });
      this.props.getUserDepartment(requestId);
    }
  }

  ItemChangeHandeler(e, item) {
    this.props.ItemQtyChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
      status: "MaterialHod",
    });
  }
  itemApprovedRequest = (item, srstatus) => {
    const servicerequest_id = this.state.requestId || this.props.srRowData.id;
    var data = {
      srstatus: srstatus,
      servicerequest_id: servicerequest_id,
      sritem_id: item.id,
      t_product_id: item.product.id,
      t_qty: item.t_qty == null ? item.qty : item.t_qty,
      t_unit: item.t_unit == null ? item.unit.id : item.t_unit.id,
      t_make: item.t_make == null ? item.make : item.t_make,
      t_description:
        item.t_description == null ? item.description : item.t_description,
      description: this.state.rejectItemText,
    };
    if (srstatus === 5) {
      Swal.fire({
        title: "Are you sure approve this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.SRitemHodApproval(data);
        }
      });
    }
    if (srstatus === 6) {
      if (data.description !== "") {
        this.props.SRitemHodApproval(data);
        this.setState({ rejectItemModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  };
  updateRequest(srstatus) {
    const servicerequest_id = this.state.requestId || this.props.srRowData.id;
    var mritems = [];
    this.props.srCustomItem.map((item) => {
      if (item.srstatus === 3 && item.itemcheck === true) {
        var ItemData = {
          srstatus: srstatus,
          servicerequest_id: servicerequest_id,
          sritem_id: item.id,
          t_product_id: item.product.id,
          t_qty: item.t_qty == null ? item.qty : item.t_qty,
          t_unit: item.t_unit == null ? item.unit.id : item.t_unit.id,
          t_make: item.t_make == null ? item.make : item.t_make,
          t_description:
            item.t_description == null ? item.description : item.t_description,
          description: this.state.rejectItemText,
        };
        mritems.push(ItemData);
      }
      return 0;
    });
    var data = {
      srstatus: srstatus,
      servicerequest_id: servicerequest_id,
      srias: mritems,
      description: this.state.rejectItemText,
    };
    if (srstatus === 5) {
      Swal.fire({
        title: "Are you sure approve this SR?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.SRHodApprovedRequest(data, this.props.history);
        }
      });
    }
    if (srstatus === 6) {
      if (data.description !== "") {
        this.props.SRHodApprovedRequest(data, this.props.history);
        this.setState({ rejectItemModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }

    // this.props.SRHodApprovedRequest(data, this.props.history);
  }

  getAllCheckedRequest(e) {
    this.props.AllMrHodItemsChecked(e.target.checked);
  }
  getCheckedRequest(e, item, index) {
    this.props.MrHODItemsChecked(e.target.checked, item, index);
  }

  CPRightbar(item) {
    if (this.state.isMobile) {
      Swal.fire({
        icon: "error",
        title: "Please use the Desktop Version",
      });
    } else {
      this.props.CPRightSidebar(item);
      var cpItem = {
        baseunitLabel: item.product.baseunit.name,
        baseunit_id: item.product.baseunit.id,
        category: item.product.category,
        department: item.product.department,
        departmentLabel: item.product.department.name,
        department_id: item.product.department.id,
        group: item.product.group,
        image_path: item.product.image_path,
        image: item.product.image,
        name: item.product.name,
        section: item.product.section,
        tax: item.product.tax,
        units: item.product.units.map((unit) => {
          return {
            name: unit.name,
            units: unit.units,
          };
        }),
        vendors: item.product.vendors,
      };
      this.props.MRCustomProduct(cpItem);
    }
  }

  render() {
    // var UserDeptIds = this.props.userDeparment.map((dept) => dept.id);
    // var customItem = [];

    // if (this.props.srRowData?.mritems) {
    //   customItem = this.props.srRowData?.mritems?.filter((item) => {
    //     if (UserDeptIds.indexOf(item.department.id) === -1) {
    //       return false;
    //     }
    //     return true;
    //   });
    // }
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <AvForm className="needs-validation">
              <Row>
                <Col md={12}>
                  <Card>
                    <CardHeader className="bg-transparent border-bottom ">
                      <Link
                        to="/srdashboard"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>

                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Service Request
                      </h5>
                      <div className="float-right">
                        <div className="d-inline-block ">
                          <Link
                            to={"/srreportdoc/" + (this.state.requestId || this.props.match.params.id)}
                            className="action-icon text-primary mr-2"
                          >
                            <Button
                              type="button"
                              outline
                              color="secondary"
                              className=" mr-2"
                              // href={"/mrreportdoc/" + this.props.match.params.id}
                              // onClick={() => window.print()}
                            >
                              <i className="mdi  mdi-printer"></i>
                              <span className="d-none d-inline-block ml-1">
                                Print
                              </span>
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-1 ">
                      <Row className="p-1">
                        <Col xl={4} className="p-1">
                          <Card className="p-1 bg-light">
                            <CardHeader
                              className="bg-transparent"
                              style={{
                                borderBottom: "1px solid #d9d9d9",
                              }}
                            >
                              <h3 className="card-title-15">
                                REQUEST DETAILS (
                                <span>
                                  <b>{this.props.srRowData.code}</b>
                                </span>
                                )
                              </h3>
                            </CardHeader>
                            <CardBody className="pt-1 bg-light">
                              <Row className="p-0">
                                <Col md="12" className="p-1 m-0">
                                  <div className="Order-panel-content">
                                    <div className="list-column">
                                      <ul className="list-style-three p-0">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            SR Issue status:
                                          </span>

                                          <span className="dtl">
                                            {this.props.srRowData.srstatus ===
                                              4 ||
                                            this.props.srRowData.srstatus ===
                                              6 ? (
                                              <>
                                                {this.props.srRowData
                                                  .srstatus === 4 && (
                                                  <span>HOD Rejected</span>
                                                )}
                                                {this.props.srRowData
                                                  .srstatus === 6 && (
                                                  <span>Admin Rejected</span>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {
                                                  this.props.srRowData
                                                    .srstatus_name
                                                }
                                              </>
                                            )}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            HOD(U) Approved by:
                                          </span>
                                          <span className="dtl">
                                            {this.props.srRowData
                                              .userDeptApprovedby &&
                                              this.props.srRowData
                                                .userDeptApprovedby[
                                                this.props.srRowData
                                                  .userDeptApprovedby.length - 1
                                              ]?.approvedby.fullname}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            HOD(U) Approved Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.srRowData
                                                .userDeptApprovedby &&
                                                this.props.srRowData
                                                  .userDeptApprovedby[
                                                  this.props.srRowData
                                                    .userDeptApprovedby.length -
                                                    1
                                                ]?.createdon
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">Location:</span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.location
                                                ?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Sub Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.sublocation
                                                ?.name
                                            }
                                          </span>
                                        </li>

                                        <li className="clearfix">
                                          <span className="ttl">
                                            Order Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.orderlocation
                                                ?.name
                                            }

                                            {this.props.srRowData.orderlocation
                                              ?.image && (
                                              <Button
                                                color="info"
                                                size="sm"
                                                className="ml-2"
                                                onClick={() =>
                                                  this.setState({
                                                    selectedOrderLocation:
                                                      this.props.srRowData
                                                        .orderlocation,
                                                    showImageModal: true,
                                                  })
                                                }
                                              >
                                                View
                                              </Button>
                                            )}
                                          </span>
                                        </li>
                                        {/* <li className="clearfix">
                                          <span className="ttl">
                                            Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.department
                                                ?.name
                                            }
                                          </span>
                                        </li> */}
                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData
                                                .userdepartment?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Name:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.srRowData.createdby
                                                ?.fullname
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Submited Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.srRowData.createdon
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Required Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.srRowData.date
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Description:
                                          </span>
                                          <span className="dtl">
                                            {this.props.srRowData.description}
                                          </span>
                                        </li>
                                        {this.props.srRowData.srstatus ===
                                          6 && (
                                          <li className="clearfix">
                                            <span className="ttl text-danger ">
                                              Reject Remark :
                                            </span>
                                            <span className="dtl">
                                              {
                                                this.props.srRowData
                                                  .sr_approvals[
                                                  this.props?.srRowData
                                                    ?.sr_approvals?.length - 1
                                                ].description
                                              }
                                            </span>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </Col>
                                {/* <Col md={12}>
                                  {this.props.srRowData.srstatus === 3 && (
                                    <>
                                      {this.props.srPedningItems.length !==
                                      0 ? (
                                        <div className="text-center border-bottom">
                                          <Label className="font-size-24  text-primary">
                                            De
                                          </Label>
                                        </div>
                                      ) : (
                                        <div className="text-center border-bottom">
                                          <Label className="font-size-24  text-primary">
                                            Pending for other Departments
                                          </Label>
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {(this.props.srRowData.srstatus === 5 ||
                                    this.props.srRowData.srstatus === 7 ||
                                    this.props.srRowData.srstatus === 8) && (
                                    <div className="text-center border-bottom">
                                      <Label className="font-size-24  text-success">
                                        Approved
                                      </Label>
                                    </div>
                                  )}
                                  {this.props.srRowData.srstatus === 6 && (
                                    <div className="text-center ">
                                      <Label className="font-size-24  text-danger">
                                        Rejected
                                      </Label>
                                    </div>
                                  )}
                                </Col> */}
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={12} xl={this.state.showImageModal ? 5 : 8}>
                          <Card className="p-1">
                            <CardBody className="pt-1">
                              <Row>
                                <Col md={12} className="mb-2">
                                  {!this.props.srRowData.loading &&
                                    this.props.srPedningItems.length !== 0 && (
                                      <div className="float-right text-center d-inline-blolck">
                                        <Button
                                          type="button"
                                          color="danger"
                                          size="sm"
                                          disabled={
                                            this.props.SRcheckedItem.length ===
                                            0
                                              ? true
                                              : false
                                          }
                                          className="waves-effect waves-light mr-2"
                                          onClick={() => this.reject_Model()}
                                        >
                                          {/* <i className="mdi mdi-thumb-down mr-2"></i>{" "} */}
                                          Reject Items (
                                          {this.props.SRcheckedItem.length})
                                        </Button>

                                        <Button
                                          type="button"
                                          className="waves-effect waves-light mr-2"
                                          color="success"
                                          size="sm"
                                          disabled={
                                            this.props.SRcheckedItem.length ===
                                            0
                                              ? true
                                              : false
                                          }
                                          onClick={() => {
                                            this.updateRequest(5);
                                          }}
                                        >
                                          {/* <i className="mdi mdi-thumb-up mr-2"></i> */}
                                          Approve Items (
                                          {this.props.SRcheckedItem.length})
                                        </Button>
                                      </div>
                                    )}
                                  <div className=" d-inline-blolck">
                                    <h3 className="card-title-15 ">
                                      Request Items List
                                    </h3>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="p-0">
                                <Col md={12} className="m-1">
                                  <div
                                    className="table-responsive m-0"
                                    style={{
                                      maxHeight: "400px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {/* <TableScrollbar height="400px"> */}
                                    <Table
                                      striped
                                      bordered
                                      hover
                                      className="mb-0 p-0 table-centered"
                                    >
                                      <thead className="bg-light text-center">
                                        <tr>
                                          <th
                                            style={{
                                              width: "20px",
                                            }}
                                          >
                                            {this.props.srPedningItems
                                              .length !== 0 && (
                                              <CustomInput
                                                type="checkbox"
                                                name="itemCheckbox"
                                                id="MRitemscheck"
                                                checked={
                                                  this.props.allItemsCheked
                                                }
                                                onChange={(e) => {
                                                  this.getAllCheckedRequest(e);
                                                }}
                                              />
                                            )}
                                            {this.props.srPedningItems
                                              .length === 0 && (
                                              <CustomInput
                                                type="checkbox"
                                                name="itemCheckbox"
                                                id="MRitemscheck"
                                                checked={true}
                                                disabled={true}
                                              />
                                            )}
                                          </th>
                                          <th className="nowrap">
                                            Item Images
                                          </th>
                                          <th
                                            style={{
                                              minWidth: "120px",
                                            }}
                                            className="nowrap"
                                          >
                                            Item Name
                                          </th>
                                          <th className="nowrap">Quantity</th>
                                          <th
                                            style={{
                                              minWidth: "180px",
                                            }}
                                          >
                                            Approved Qty
                                          </th>
                                          <th className="nowrap">Item Issue</th>
                                          <th className="nowrap">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.props.srCustomItem.map(
                                          (item, key) => (
                                            <tr key={item.id}>
                                              <td className="nowrap text-center">
                                                {item.srstatus === 3 && (
                                                  <CustomInput
                                                    type="checkbox"
                                                    name="MRlistItem"
                                                    id={"mRitemscheck" + key}
                                                    checked={item.itemcheck}
                                                    disabled={
                                                      item.product.active ===
                                                      true
                                                        ? false
                                                        : true
                                                    }
                                                    onChange={(e) => {
                                                      this.getCheckedRequest(
                                                        e,
                                                        item,
                                                        key
                                                      );
                                                    }}
                                                  />
                                                )}
                                                {item.srstatus !== 3 && (
                                                  <CustomInput
                                                    type="checkbox"
                                                    name="MRlistItem"
                                                    id={"mRitemscheck" + key}
                                                    checked={true}
                                                    disabled={true}
                                                  />
                                                )}
                                              </td>
                                              <td className="text-center">
                                                <div className="product-detail text-center">
                                                  <img
                                                    src={
                                                      item?.product?.image ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.product?.image
                                                    }
                                                    alt="product-img"
                                                    title="product-img"
                                                    className="product-img  img-fluid mx-auto tab-img rounded"
                                                    style={{
                                                      height: "100px",
                                                      width: "150px",
                                                    }}
                                                  />
                                                </div>
                                                {/* <img
                                                  src={
                                                    item?.product?.image == null
                                                      ? DefaultImg
                                                      : item?.product?.image
                                                  }
                                                  alt="product-img"
                                                  title="product-img"
                                                  className="avatar-sm"
                                                /> */}
                                              </td>
                                              <td
                                                style={{
                                                  minWidth: "220px",
                                                }}
                                              >
                                                <h5 className="font-size-14 ">
                                                  <Link
                                                    to="#"
                                                    onClick={() => {
                                                      this.tog_static(item);
                                                    }}
                                                    className="text-dark mr-2"
                                                  >
                                                    {item?.product?.name}
                                                  </Link>
                                                  {!item.product.active && (
                                                    <i className="text-danger ri-spam-line"></i>
                                                  )}
                                                  {item.sri_approvals.length !==
                                                    0 && (
                                                    <>
                                                      <Link
                                                        to="#"
                                                        onClick={() => {
                                                          this.props.productItemHistoryModelOpen(
                                                            item.sri_approvals
                                                          );
                                                        }}
                                                        className="text-dark"
                                                      >
                                                        <i className=" text-primary ri-eye-fill ml-2"></i>
                                                      </Link>
                                                    </>
                                                  )}
                                                  {item.srstatus === 3 && (
                                                    <>
                                                      <>
                                                        <Link
                                                          to="#"
                                                          // onClick={this.CPRightbar}
                                                          onClick={() => {
                                                            this.props.ChangeItemModelOpen(
                                                              item,
                                                              "MRHod"
                                                            );
                                                            this.props.getAllProducts(
                                                              {
                                                                ...this.props
                                                                  .params,
                                                                search: "",
                                                                page: 1,
                                                                type: 2,
                                                              },
                                                              true
                                                            );
                                                          }}
                                                          className="ml-2 text-primary"
                                                        >
                                                          <i className="ri-pencil-line"></i>
                                                        </Link>
                                                        {item.product.active ===
                                                          false && (
                                                          <Link
                                                            to="#"
                                                            onClick={() => {
                                                              this.CPRightbar(
                                                                item
                                                              );
                                                            }}
                                                            className="ml-2 text-primary"
                                                          >
                                                            <i className="ri-add-circle-line"></i>
                                                          </Link>
                                                        )}
                                                      </>
                                                    </>
                                                  )}
                                                  {item.product.active ===
                                                    true && (
                                                    <Link
                                                      to="#"
                                                      onClick={() => {
                                                        this.props.GetProductHistory(
                                                          item.product.id
                                                        );
                                                      }}
                                                      className="ml-2 text-info"
                                                    >
                                                      <i className="ri-history-fill"></i>
                                                    </Link>
                                                  )}
                                                </h5>

                                                <p className="mb-0">
                                                  <b className="text-dark">
                                                    Make :
                                                  </b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.make}
                                                  </span>
                                                </p>
                                                <p className="mb-0">
                                                  <b className="text-dark">
                                                    Description :
                                                  </b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.description}
                                                  </span>
                                                </p>
                                                {item.srstatus === 6 && (
                                                  <p className="mb-0">
                                                    <b className="text-danger ">
                                                      Reject Remark :
                                                    </b>{" "}
                                                    <span>
                                                      {
                                                        item.sri_approvals[
                                                          item.sri_approvals
                                                            .length - 1
                                                        ].description
                                                      }
                                                    </span>
                                                  </p>
                                                )}
                                              </td>
                                              <td className="text-center">
                                                {item.sri_approvals.length === 0
                                                  ? item.qty +
                                                    " " +
                                                    item.unit?.name
                                                  : item.sri_approvals[0]
                                                      .f_qty +
                                                    " " +
                                                    item.sri_approvals[0].f_unit
                                                      .name}
                                              </td>

                                              <td
                                                style={{
                                                  minWidth: "220px",
                                                }}
                                                className="nowrap text-center"
                                              >
                                                {item.srstatus === 3 ? (
                                                  <>
                                                    <FormGroup
                                                      row
                                                      className="mb-0"
                                                    >
                                                      <Col xs={3} sm={3} md={3}>
                                                        <Label
                                                          htmlFor="Qty"
                                                          className="col-form-label float-left"
                                                        >
                                                          Qty :
                                                        </Label>
                                                      </Col>
                                                      <Col xs={9} sm={9} md={9}>
                                                        <AvField
                                                          placeholder="Quantity"
                                                          className=" pr-0form-control"
                                                          min={0}
                                                          // max={100}
                                                          type="number"
                                                          // step="1"
                                                          name={key + "qty"}
                                                          id="qty"
                                                          value={item.qty}
                                                          validate={{
                                                            required: {
                                                              value: true,
                                                              errorMessage:
                                                                "Please enter Qty",
                                                            },
                                                            pattern: {
                                                              value:
                                                                "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                              errorMessage:
                                                                "Qty can compose numbers and 3 decimals ",
                                                            },
                                                          }}
                                                          onChange={(e) =>
                                                            this.ItemChangeHandeler(
                                                              e,
                                                              item
                                                            )
                                                          }
                                                        />
                                                      </Col>
                                                    </FormGroup>
                                                    <FormGroup
                                                      row
                                                      className="mb-0"
                                                    >
                                                      <Col xs={3} sm={3} md={3}>
                                                        <Label
                                                          htmlFor="Units"
                                                          className="col-form-label float-left"
                                                        >
                                                          Units :
                                                        </Label>
                                                      </Col>
                                                      <Col xs={9} sm={9} md={9}>
                                                        <Select
                                                          id="units_select"
                                                          name="units_select"
                                                          required="required"
                                                          options={item?.product?.units?.map(
                                                            (i) => ({
                                                              label: i.name,
                                                              value: i.id,
                                                            })
                                                          )}
                                                          value={{
                                                            label:
                                                              item.t_unit ==
                                                              null
                                                                ? item?.unit
                                                                    ?.name
                                                                : item.t_unit
                                                                    .name,

                                                            value:
                                                              item.t_unit ==
                                                              null
                                                                ? item?.unit?.id
                                                                : item.t_unit
                                                                    .id,
                                                          }}
                                                          onChange={(e) => {
                                                            this.props.ItemUnitsChangeValue(
                                                              {
                                                                label: e.label,
                                                                value: e.value,
                                                                item,
                                                                status:
                                                                  "MaterialHod",
                                                              }
                                                            );
                                                          }}
                                                        />
                                                      </Col>
                                                    </FormGroup>
                                                  </>
                                                ) : (
                                                  item.qty +
                                                  " " +
                                                  item.unit?.name
                                                )}
                                              </td>
                                              <td className="text-center">
                                                {item.srstatus === 4 ||
                                                item.srstatus === 6 ? (
                                                  <>
                                                    {item.srstatus === 4 && (
                                                      <span>HOD Rejected</span>
                                                    )}
                                                    {item.srstatus === 6 && (
                                                      <span>
                                                        Admin Rejected
                                                      </span>
                                                    )}
                                                  </>
                                                ) : (
                                                  <> {item.srstatus_name}</>
                                                )}
                                              </td>

                                              <td className="nowrap text-center">
                                                {item.srstatus !== 1 &&
                                                  item.srstatus !== 2 &&
                                                  item.srstatus !== 3 && (
                                                    <Badge
                                                      className="font-size-14"
                                                      color={
                                                        item.srstatus === 1 ||
                                                        item.srstatus === 2 ||
                                                        item.srstatus === 3
                                                          ? "primary"
                                                          : item.srstatus ===
                                                              5 ||
                                                            item.srstatus ===
                                                              7 ||
                                                            item.srstatus ===
                                                              8 ||
                                                            item.srstatus ===
                                                              11 ||
                                                            item.srstatus === 12
                                                          ? "success"
                                                          : "danger"
                                                      }
                                                    >
                                                      {item.srstatus_name}
                                                    </Badge>
                                                  )}
                                                {/* {(item.srstatus === 5 ||
                                                  item.srstatus === 7 ||
                                                  item.srstatus === 8) && (
                                                  <Badge
                                                    className="font-size-14"
                                                    color="success"
                                                  >
                                                    Admin Approved
                                                  </Badge>
                                                )}
                                                {item.srstatus === 6 && (
                                                  <Badge
                                                    className="font-size-14"
                                                    color="danger"
                                                  >
                                                    Admin Rejected
                                                  </Badge>
                                                )}
                                                {item.srstatus === 4 && (
                                                  <Badge
                                                    className="font-size-14"
                                                    color="danger"
                                                  >
                                                    HOD Rejected
                                                  </Badge>
                                                )} */}
                                                {!this.props.srRowData
                                                  .loading && (
                                                  <>
                                                    {item.srstatus === 3 && (
                                                      <>
                                                        <Button
                                                          type="button"
                                                          color="success"
                                                          className="waves-effect waves-light mr-2"
                                                          disabled={
                                                            item.product
                                                              .active === true
                                                              ? false
                                                              : true
                                                          }
                                                          onClick={() => {
                                                            this.itemApprovedRequest(
                                                              item,
                                                              5
                                                            );
                                                          }}
                                                        >
                                                          <i className="mdi mdi-check"></i>
                                                        </Button>
                                                        <Button
                                                          type="button"
                                                          color="danger"
                                                          className="waves-effect waves-light"
                                                          onClick={() =>
                                                            this.reject_Item_Model(
                                                              item
                                                            )
                                                          }
                                                        >
                                                          <i className="mdi mdi-close"></i>
                                                        </Button>
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                    {/* </TableScrollbar> */}
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>

                        {this.state.showImageModal &&
                          this.state.selectedOrderLocation?.image && (
                            <Col md={12} xl={3}>
                              <Card className="p-1">
                                <CardHeader>
                                  <h5>
                                    Order Location Document:{" "}
                                    {this.state.selectedOrderLocation.name}
                                  </h5>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() =>
                                      this.setState({
                                        showImageModal: false,
                                      })
                                    }
                                  >
                                    Close
                                  </Button>
                                </CardHeader>
                                <CardBody className="p-0">
                                  {this.state.selectedOrderLocation?.image ? (
                                    (() => {
                                      const rawUrl =
                                        this.state.selectedOrderLocation.image;
                                      const cleanUrl = rawUrl.trim();
                                      const isPdf = /\.pdf(\?.*)?$/i.test(
                                        cleanUrl
                                      );

                                      return isPdf ? (
                                        <PdfViewer url={cleanUrl} />
                                      ) : (
                                        <img
                                          src={cleanUrl}
                                          alt="Order Location"
                                          style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                          }}
                                        />
                                      );
                                    })()
                                  ) : (
                                    <p style={{ padding: 10 }}>
                                      No document available
                                    </p>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                      </Row>
                      <CardFooter className="bg-transparent pt-0">
                        <div className="float-right">
                          <Button
                            type="reset"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/srdashboard"
                          >
                            Cancel
                          </Button>
                          {/* {!this.props.srRowData.loading &&
                            this.props.srRowData.srstatus !== 5 && (
                              <>
                                <Button
                                  type="submit"
                                  color="success"
                                  onClick={() => {
                                    this.updateRequest(5);
                                  }}
                                  className="waves-effect waves-light mr-2"
                                >
                                  Update & Approved
                                </Button>
                              </>
                            )} */}
                        </div>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            {/* Change Item Model */}
            <ChangeItem />
            {/* CustomProductRightbar */}
            <CustomProductRightbar />
            {/* CustomProductRightbar end */}
            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="MRLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
            <Modal
              isOpen={this.state.rejectItemModel}
              toggle={this.reject_Item_Model}
              backdrop="static"
              centered
              // size="lg"
            >
              <ModalHeader
                toggle={() => this.setState({ rejectItemModel: false })}
              >
                Reject Remark
              </ModalHeader>
              <ModalBody className="pt-0">
                <Input
                  className="mb-0 form-control "
                  type="textarea"
                  step="1"
                  name="reject"
                  id="reject_item"
                  value={this.state.rejectItemText}
                  onChange={(e) =>
                    this.setState({
                      rejectItemText: e.target.value,
                    })
                  }
                  placeholder="Reject Description"
                />
                {this.state.rejectErrorMsg !== "" && (
                  <span className="text-danger mt-0">
                    {this.state.rejectErrorMsg}
                  </span>
                )}
                <div className="float-right mt-2">
                  <FormGroup>
                    <Button
                      type="button"
                      color="light "
                      className="waves-effect waves-light d-inline-block mr-2"
                      onClick={() =>
                        this.setState({
                          rejectItemModel: false,
                        })
                      }
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      color="primary"
                      className="waves-effect waves-light d-inline-block"
                      onClick={() => {
                        this.itemApprovedRequest(this.state.rejectItem, 6);
                      }}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                </div>
              </ModalBody>
            </Modal>
            <Modal
              isOpen={this.state.rejectModel}
              toggle={this.reject_Model}
              backdrop="static"
              centered
              // size="lg"
            >
              <ModalHeader toggle={() => this.setState({ rejectModel: false })}>
                Reject Remark
              </ModalHeader>
              <ModalBody className="pt-0">
                <Input
                  className="mb-0 form-control "
                  type="textarea"
                  step="1"
                  name="reject"
                  id="reject_item"
                  value={this.state.rejectItemText}
                  onChange={(e) =>
                    this.setState({
                      rejectItemText: e.target.value,
                    })
                  }
                  placeholder="Reject Description"
                />
                {this.state.rejectErrorMsg !== "" && (
                  <span className="text-danger mt-0">
                    {this.state.rejectErrorMsg}
                  </span>
                )}
                <div className="float-right mt-2">
                  <FormGroup>
                    <Button
                      type="button"
                      color="light "
                      className="waves-effect waves-light d-inline-block mr-2"
                      onClick={() =>
                        this.setState({
                          rejectModel: false,
                        })
                      }
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      color="primary"
                      className="waves-effect waves-light d-inline-block"
                      onClick={() => {
                        this.updateRequest(6);
                      }}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                </div>
              </ModalBody>
            </Modal>
            <ProductItemHistoryLog />
            <ProductHistory />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const {
    srRowData,
    reqrowdata,
    srCustomItem,
    srPedningItems,
    SRcheckedItem,
    allItemsCheked,
    loading,
  } = state.Servicerequest;
  return {
    srRowData,
    reqrowdata,
    srCustomItem,
    srPedningItems,
    SRcheckedItem,
    allItemsCheked,
    loading,
  };
};

export default connect(mapStatetoProps, {
  getUserDepartment,
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  getReqestRowDetails,
  SRitemHodApproval,
  SRHodApprovedRequest,
  AllMrHodItemsChecked,
  MrHODItemsChecked,
  ChangeItemModelOpen,
  getAllProducts,
  CPRightSidebar,
  MRCustomProduct,
  GetProductHistory,
  productItemHistoryModelOpen,
})(MaterialRequest);
